import "@fontsource/ibm-plex-sans-thai/400.css";
import "@fontsource/ibm-plex-sans-thai/500.css";
import "@fontsource/ibm-plex-sans-thai/600.css";
import "./style.css";

import { bindPhone, fetchStatus } from "./api";
import { initLiffAuth } from "./liff";
import { isValidThaiPhone, normalizePhone } from "./format";
import {
  renderBinding,
  renderError,
  renderLineEntryInstruction,
  renderLoading,
  renderStatus,
  renderEmpty,
} from "./views";

const app = document.querySelector<HTMLDivElement>("#app")!;

function mount(node: HTMLElement) {
  app.replaceChildren(node);
}

async function run() {
  mount(renderLoading());

  let auth;
  try {
    auth = await initLiffAuth();
  } catch (e) {
    if (String(e).includes("redirecting")) return;
    mount(
      renderLineEntryInstruction({
        title: "เปิดจาก LINE ร้าน",
        subtitle: "สถานะผ้าซัก",
        richMenuLabel: "เช็คสถานะผ้า",
      }),
    );
    console.error("LIFF auth failed", e);
    return;
  }

  try {
    const data = await fetchStatus(auth);

    if (!data.bound) {
      mount(
        renderBinding(async (rawPhone) => {
          const phone = normalizePhone(rawPhone);
          if (!isValidThaiPhone(phone)) {
            mount(renderError("เบอร์ไม่ถูกต้อง ลองใหม่หรือติดต่อร้าน"));
            return;
          }
          mount(renderLoading());
          try {
            const bound = await bindPhone(auth, phone);
            if (bound.ok && bound.order) {
              mount(renderStatus(bound.order));
            } else {
              mount(
                renderEmpty(
                  bound.error ??
                    "ไม่พบออเดอร์ค้างที่ตรงกับเบอร์นี้ — ตรวจกับร้านว่าบันทึกแล้ว",
                ),
              );
            }
          } catch {
            mount(renderError("เชื่อมต่อไม่สำเร็จ ลองใหม่อีกครั้ง"));
          }
        }),
      );
      return;
    }

    if (data.order) {
      mount(renderStatus(data.order));
      return;
    }

    mount(
      renderEmpty(data.message ?? "ยังไม่พบออเดอร์ — ติดต่อร้าน"),
    );
  } catch (e) {
    const message = e instanceof Error ? e.message : String(e);
    mount(renderError(message || "โหลดข้อมูลไม่สำเร็จ ลองใหม่อีกครั้ง"));
  }
}

run();
